export default "123213:330:P, 123018:547:P, 71916:780:P, 71627:509:P, 72019:495:P\n";